"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Infrastructure() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: paraRef,
    isVisible: paraVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="15217" id="architects-of-infrastructure" className="bg-background text-foreground py-40 md:py-56 px-5 md:px-12">
      <div className="mx-auto max-w-[1440px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-6">
          {}
          <div className="lg:col-span-8">
            <h1 ref={headlineRef} className="font-default font-medium text-foreground" style={{
            fontSize: "clamp(2.5rem, 9vw, 8.5rem)",
            letterSpacing: "-0.025em",
            lineHeight: "0.92",
            opacity: headlineVisible ? 1 : 0,
            transform: headlineVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 520ms cubic-bezier(0.2, 0.7, 0.2, 1), transform 520ms cubic-bezier(0.2, 0.7, 0.2, 1)"
          }}>
              <span>Operational systems for contractors who demand </span>
              <em className="not-italic" style={{
              fontStyle: "italic",
              color: "var(--primary)",
              opacity: headlineVisible ? 1 : 0,
              transition: "opacity 180ms ease-out 520ms"
            }}>
                precision
              </em>
              <span>.</span>
            </h1>
          </div>

          {}
          <div className="lg:col-span-4 flex flex-col justify-end">
            <div ref={paraRef} style={{
            opacity: paraVisible ? 1 : 0,
            transform: paraVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 520ms cubic-bezier(0.2, 0.7, 0.2, 1) 60ms, transform 520ms cubic-bezier(0.2, 0.7, 0.2, 1) 60ms"
          }}>
              <p className="font-default font-normal text-foreground/[0.78]" style={{
              fontSize: "clamp(1.125rem, 1.2vw, 1.25rem)",
              letterSpacing: "-0.005em",
              lineHeight: "1.5"
            }}>
                A high-end operational consultancy building, integrating, and modernizing backend systems for the modern trade professional.
              </p>

              <div className="mt-8">
                <div className="h-px w-full" style={{
                backgroundColor: "hsl(210 10% 12% / 0.1)"
              }} />
                <p className="mt-4 font-mono text-foreground/70 uppercase" style={{
                fontSize: "clamp(0.75rem, 0.8vw, 0.8125rem)",
                letterSpacing: "0.08em",
                lineHeight: "1.4"
              }}>
                  {"CRM \u00B7 FSM \u00B7 Bookkeeping \u00B7 Scheduling \u00B7 Invoicing"}
                </p>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-24 md:mt-32 grid grid-cols-1 lg:grid-cols-12">
          <div ref={ctaRef} className="lg:col-span-4" style={{
          opacity: ctaVisible ? 1 : 0,
          transform: ctaVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 520ms cubic-bezier(0.2, 0.7, 0.2, 1) 120ms, transform 520ms cubic-bezier(0.2, 0.7, 0.2, 1) 120ms"
        }}>
            <Button asChild variant="outline" className="group h-auto border bg-transparent text-foreground px-7 py-3.5 text-sm font-medium tracking-normal hover:bg-transparent hover:text-primary hover:border-primary transition-colors duration-200" style={{
            borderColor: "hsl(210 10% 12% / 0.2)"
          }}>
              <Link to="/ServicesPage">
                <span>View our framework</span>
                <span aria-hidden="true" className="inline-block transition-transform duration-200 group-hover:translate-x-1">
                  {"\u2192"}
                </span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}